export default "__VITE_ASSET__B36X0MXG__"